export const ReplaceNullWithEmptyString = (obj) => {
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (obj[key] === null) {
                obj[key] = '';
            }
        }
    }
    return obj;
}
